import { BaseDialog } from '@airship-platform/jam-web/components';
import { Appointment } from '../../../../data-access/appointments';
import CallSummaries from '../details-page/CallSummaries';

interface ProposalAISummaryModalProps {
  open: boolean;
  onClose: () => void;
  summaries: Appointment['job']['callSummaries'];
}

const ProposalAISummaryModal: React.FC<ProposalAISummaryModalProps> = ({
  open,
  onClose,
  summaries,
}) => (
  <BaseDialog title="AI call summary" open={open} onClose={onClose}>
    <CallSummaries summaries={summaries} />
  </BaseDialog>
);

export default ProposalAISummaryModal;
